import { render } from "./Campus.vue?vue&type=template&id=daf55c4a&scoped=true"
import script from "./Campus.vue?vue&type=script&lang=js"
export * from "./Campus.vue?vue&type=script&lang=js"

import "./Campus.vue?vue&type=style&index=0&id=daf55c4a&scoped=true&lang=css"

import exportComponent from "C:\\wamp64\\www\\tafe-raap-ui\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-daf55c4a"]])

export default __exports__